import React, { useState } from "react";

import TableChartIco from "../../../../components/icons/TableChartIco";
import HorizontalBarIco from "../../../../components/icons/HorizontalBarIco";
import PieChartIco from "../../../../components/icons/PieChartIco";
import PinIco from "../../../../components/icons/PinIco";
import PerformanceLineIco from "../../../../components/icons/PerformanceLineIco";
import MultiMetricIco from "../../../../components/icons/MultiMetricIco";
import { useWidgets } from "../../../../providers/WidgetContext";
import { useDashboards } from "../../../../providers/DashboardContext";
import Modal from "../../../../components/Modal";
import { createWidget } from "../../../../services/apiWidgests";
import { useAuth } from "../../../../providers/AuthContext";

// process widgets
import TimeRateChartForm from "../widgets/TimeRateChart/TimeRateChartForm";
import MetricForm from "../widgets/Metric/MetricForm";
import MultiMetricForm from "../widgets/MultiMetric/MultiMetricForm";
import HorizontalBarChartForm from "../widgets/HorizontalBarChart/HorizontalBarChartForm";
import RegistersTableForm from "../widgets/RegistersTable/RegistersTableForm";
import PieChartForm from "../widgets/PieChart/PieChartForm";

// telemetry widgets
import TelemetryHorizontalBarChartForm from "../../../dashboards/widgets/TelemetryHorizontalBarChart/TelemetryHorizontalBarChartForm";
import TelemetryLineChartForm from "../../../dashboards/widgets/TelemetryLineChart/TelemetryLineChartForm";
import TelemetryMetricForm from "../../../dashboards/widgets/TelemetryMetric/TelemetryMetricForm";
import TelemetryPieChartForm from "../../../dashboards/widgets/TelemetryPieChart/TelemetryPieChartForm";
import TelemetryRegistersTableForm from "../../../dashboards/widgets/TelemetryRegistersTable/TelemetryRegistersTableForm";
import PorcentualRateChartForm from "../widgets/PorcentualRateChart/PorcentualRateChartForm";
import PercentualLineIco from "../../../../components/icons/PorcentualLineIco";
import ManufacturingIco from "../../../../components/icons/ManufacturingIco";
import OEEForm from "../widgets/OEE/OEEForm";
import ProblemIco from "../../../../components/icons/ProblemIco";
import StatusRegisterForm from "../widgets/StatusRegister/StatusRegisterForm";
import EventUpcoming from "../../../../components/icons/EventUpcoming";
import PlanningTableForm from "../widgets/PlanningTable/PlanningTableForm";

const widgets = [
  { name: "Tabla de valores", icon: TableChartIco, type: "processTable" , module : "process"},
  {
    name: "Gráfico de barras",
    icon: HorizontalBarIco,
    type: "processHorizontalBarChart",
    module : "process"
  },
  { name: "Gráfico Pastel", icon: PieChartIco, type: "processPieChart" , module : "process" },
  { name: "Métrica", icon: PinIco, type: "processMetric", module : "process" },
  { name: "Métrica Múltiple", icon: MultiMetricIco, type: "processMultiMetric", module : "process" },
  { name: "Gráfico de Rendimiento", icon: PerformanceLineIco, type: "processTimeRate", module : "process" },
  { name: "Gráfico Porcentual", icon: PercentualLineIco, type: "processPorcentualTimeRate", module : "process" },
  { name: "OEE", icon: ManufacturingIco, type: "processOEE", module : "process" },
  { name: "Estado Registro", icon: ProblemIco, type: "processStatusRegister", module : "process" },
  { name: "Planificación", icon: EventUpcoming, type: "processPlanning", module : "process" },
  // telemetria
  { name: "Gráfico de linea", icon: PerformanceLineIco, type: "telemetryLineGraph", module : "telemetry" },
  { name: "Métrica", icon: PinIco, type: "telemetryMetric", module : "telemetry" },
  {
    name: "Gráfico de barras",
    icon: HorizontalBarIco,
    type: "telemetryHorizontalBarChart",
    module : "telemetry"
  },
  { name: "Gráfico Pastel", icon: PieChartIco, type: "telemetryPieChart" , module : "telemetry" },
  { name: "Tabla de valores", icon: TableChartIco, type: "telemetryTable" , module : "telemetry"}
];

const WidgetCard = ({
  widget,
  toggleModal,
  setShowWidgetForm,
  setTitleForm,
  setTypeForm,
}) => {
  const { dashboard } = useDashboards();
  //const { addCard, createCard } = useWidgets();

  const handleAdd = async (dashboardId) => {
    //createCard(widget.type, dashboardId);
    setShowWidgetForm(true);
    setTitleForm(widget.name);
    setTypeForm(widget.type);
    /* if (widget.type === "processTable"){
      setContentForm(RegistersTableForm)
    }
    else{
      setShowWidgetForm(false);
      toggleModal();
      addCard(widget.type)
    } */
  };
  return (
    <>
      <div
        className="flex flex-col border rounded-md w-32 h-32 shadow-md transform transition-transform duration-300 hover:scale-105 cursor-pointer"
        onClick={() => handleAdd(dashboard._id)}
      >
        <div className="flex basis-2/3 items-center justify-center">
          <widget.icon fill={"darkgray"} height={"50px"} width={"50px"} />
        </div>
        <div className="basis-1/3 flex items-center text-center justify-center border-t">
          {widget.name}
        </div>
      </div>
    </>
  );
};

function NewWidget({ toggleNewWidgetModal}) {
  const [showWidgetForm, setShowWidgetForm] = useState(false);
  const { module } = useDashboards();
  const [titleForm, setTitleForm] = useState("");
  const [typeForm, setTypeForm] = useState("");

  return (
    <div className="flex flex-wrap w-full h-96 gap-3 ">
      <Modal
        isOpen={showWidgetForm}
        onClose={() => {
          setShowWidgetForm(false);
        }}
        title={titleForm}
        customType={2}
        colorTitle="bg-bluesens"
        size="w-2/4"
      >
        {/*telemetry */}
        {/* typeForm === "telemetryTable" && <TelemetryRegistersTableForm onSubmit={toggleNewWidgetModal} /> */}
        {/* typeForm === "telemetryHorizontalBarChart" && <TelemetryHorizontalBarChartForm onSubmit={toggleNewWidgetModal} /> */}
        {/* typeForm === "telemetryPieChart" && <TelemetryPieChartForm onSubmit={toggleNewWidgetModal} /> */}
        {/* typeForm === "telemetryMetric" && <TelemetryMetricForm onSubmit={toggleNewWidgetModal} /> */}
        {typeForm === "telemetryLineGraph" && <TelemetryLineChartForm onSubmit={toggleNewWidgetModal} />}
        {/*process */}
        {typeForm === "processTable" && <RegistersTableForm onSubmit={toggleNewWidgetModal} />}
        {typeForm === "processHorizontalBarChart" && <HorizontalBarChartForm onSubmit={toggleNewWidgetModal} />}
        {typeForm === "processPieChart" && <PieChartForm onSubmit={toggleNewWidgetModal} />}
        {typeForm === "processMetric" && <MetricForm onSubmit={toggleNewWidgetModal} />}
        {typeForm === "processMultiMetric" && <MultiMetricForm onSubmit={toggleNewWidgetModal} />}
        {typeForm === "processTimeRate" && <TimeRateChartForm onSubmit={toggleNewWidgetModal} />}
        {typeForm === "processPorcentualTimeRate" && <PorcentualRateChartForm onSubmit={toggleNewWidgetModal} />}
        {typeForm === "processOEE" && <OEEForm onSubmit={toggleNewWidgetModal} />}
        {typeForm === "processStatusRegister" && <StatusRegisterForm onSubmit={toggleNewWidgetModal} />}
        {typeForm === "processPlanning" && <PlanningTableForm onSubmit={toggleNewWidgetModal} />}
      </Modal>
      {widgets.filter(widget => widget.module === module).map((widget, index) => (
        <WidgetCard
          key={index}
          widget={widget}
          toggleModal={toggleNewWidgetModal}
          setShowWidgetForm={setShowWidgetForm}
          setTitleForm={setTitleForm}
          setTypeForm={setTypeForm}
        />
      ))}
    </div>
  );
}

export default NewWidget;
